import { render } from "./SetAvatar.vue?vue&type=template&id=ce830e5e"
import script from "./SetAvatar.vue?vue&type=script&lang=js"
export * from "./SetAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__